/* eslint-disable */
import React, { useState, useEffect } from "react";

const DISCLAIMER_TEXT =
  "Regulens provides general informational content only and does not constitute legal advice, tax advice, or any professional advisory service. No information provided by Regulens creates or implies any legal obligation, duty, or liability. All regulatory data is sourced from publicly available government publications. Laws change frequently and information may not reflect the most current legal developments. Always consult a licensed attorney and qualified tax professional before making any business, legal, or financial decisions. Use of Regulens does not establish an attorney-client or advisor-client relationship of any kind.";

export const Disclaimer = ({ compact = false }) => (
  <div className={`rounded-md border border-[var(--rg-border)] bg-[var(--rg-surface)]/60 ${compact ? "p-3" : "p-4"} text-xs text-[var(--rg-muted)] leading-relaxed`} data-testid="legal-disclaimer">
    <span className="font-bold text-[var(--rg-text)] uppercase tracking-[0.16em] mr-2">Informational only:</span>
    {DISCLAIMER_TEXT}
  </div>
);

const STORAGE_KEY = "regulens_disclaimer_ack_v4";

export const FirstLoginDisclaimerModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setOpen(true);
    }
  }, []);

  const acknowledge = () => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur" data-testid="first-login-disclaimer">
      <div className="max-w-2xl w-full rounded-lg border border-[var(--rg-sage)] bg-[var(--rg-surface)] p-6">
        <div className="text-[10px] uppercase tracking-[0.24em] font-bold text-[var(--rg-sage)] mb-2">Welcome to Regulens · One quick note</div>
        <h2 className="font-heading font-extrabold text-2xl text-[var(--rg-text-strong)] mb-3">Informational readiness only — not legal advice</h2>
        <p className="text-sm text-[var(--rg-text)] leading-relaxed mb-5">{DISCLAIMER_TEXT}</p>
        <button
          onClick={acknowledge}
          data-testid="disclaimer-acknowledge"
          className="w-full bg-[var(--rg-sage)] text-[var(--rg-on-sage)] hover:bg-[var(--rg-sage-hover)] font-semibold py-2.5 rounded-md transition-fast"
        >
          I understand — continue
        </button>
      </div>
    </div>
  );
};

export default Disclaimer;
